import Base from "./_BaseComponent";
import $ from "jquery";

class Dropdowntable extends Base.Component {
	private iconEl: JQuery;

	public onMount(): void {
		this.element.find("[data-bind=toggle]").on("click", this.toggle.bind(this));
		this.iconEl = this.element.find("[data-bind=icon]");
	}

	private toggle(e: any): void {
		this.element.toggleClass("open");
		if (this.element.hasClass("open"))
			this.iconEl.text("-");
		else
			this.iconEl.text("+");
	}

}

export default Base.Init("[data-component-dropdown-table]", Dropdowntable);
